import axios from "axios";
import Cookies from "js-cookie";
import { message } from "antd";

const server = axios.create({
  baseURL: "https://apiv2.ecofitnesshub.com/api/v1/",
  headers: { "Content-Type": "application/json" },
});

server.interceptors.request.use((config) => {
  const token = Cookies.get("ecofitness-token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  return config;
});

server.interceptors.response.use(
  (response) => {
    if (response.data.responseCode) {
      response.data.responseCode = Number(response.data.responseCode);
    } else {
      response.data.responseCode = Number(response.data.responsecode);
    }

    if (response.data.responsemessage) {
      response.data.responseMessage = response.data.responsemessage;
    }

    return response.data;
  },
  (err) => {
    if (err.response && [401, 403].includes(err.response.status)) {
      Cookies.remove("ecofitness-token");
      if (403 === err.response.status) {
        message.warning("Your Session has Expired kindly Login again", 8);
      }

      localStorage.clear();
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
    return Promise.reject(err);
  }
);

// Request deduplication logic
const pendingRequests = new Map();

const getRequestKey = (config) => {
  return `${config.method}:${config.url}${
    config.params ? JSON.stringify(config.params) : ""
  }`;
};

const originalGet = server.get.bind(server);

server.get = function (url, config = {}) {
  const requestKey = getRequestKey({ method: "get", url, ...config });

  if (pendingRequests.has(requestKey)) {
    console.log(`[Axios Cache] Deduplicating request: ${url}`);
    return pendingRequests.get(requestKey);
  }

  const promise = originalGet(url, config).finally(() => {
    pendingRequests.delete(requestKey);
  });

  pendingRequests.set(requestKey, promise);
  return promise;
};

export default server;
